// extracted by mini-css-extract-plugin
export default {"main":"_568c66413f _2f0d6e25dd","xmark":"c5f7e4d43f","fl_img":"deff62d056 _62a4dc92fb"};